var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dtw"
  }, [_c('main', {
    staticClass: "dtw__main"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('header', [_c('nuxt-link', {
    attrs: {
      "to": _vm.localePath('/')
    }
  }, [_c('i', {
    staticClass: "pi pi-arrow-left"
  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('all.allCompanies')))])], 1), _vm._v(" "), _c('section', {
    staticClass: "section section--show"
  }, [_c('form', {
    staticClass: "home__search",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.searchMethod();
      }
    }
  }, [_c('span', {
    staticClass: "p-input-icon-left"
  }, [_c('i', {
    staticClass: "pi pi-map-marker"
  }), _vm._v(" "), _c('InputText', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.city').toString()
    },
    model: {
      value: _vm.search.city,
      callback: function ($$v) {
        _vm.$set(_vm.search, "city", $$v);
      },
      expression: "search.city"
    }
  })], 1), _vm._v(" "), _c('Button', {
    staticClass: "p-button-rounded",
    attrs: {
      "label": "CERCA"
    },
    on: {
      "click": function ($event) {
        return _vm.searchMethod();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field-checkbox"
  }, [_c('Checkbox', {
    attrs: {
      "id": "positions",
      "binary": true
    },
    model: {
      value: _vm.search.open,
      callback: function ($$v) {
        _vm.$set(_vm.search, "open", $$v);
      },
      expression: "search.open"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "positions"
    }
  }, [_vm._v(_vm._s(_vm.$t('all.withOpenPositions')))])], 1)], 1)]), _vm._v(" "), _vm.openPositions.length > 0 ? _c('ul', {
    staticClass: "dtw__blocks companies",
    attrs: {
      "id": "contenitore-aziende-verticale"
    }
  }, _vm._l(_vm.openPositions, function (item, index) {
    return _c('Company', {
      key: index,
      attrs: {
        "id": 'singola-azienda-verticale-' + (index + 1),
        "company": item
      }
    });
  }), 1) : _c('span', {
    staticClass: "noCompaniesMessage"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('all.noCompanies')) + "\n      ")])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }